import { IPassportMassCancelReason } from '../../../APIPackage/CatalogsModule/interfaces/IPassportMassCancelReason';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export function createPassportMassCancelReasonSelectOption(reason: IPassportMassCancelReason): ISelectOption {
  return {
    ...reason,
    label: reason.name,
  };
}
